 const MUTATIONS = {};
 /**
  * Map takes in single object and a list of mappings.
  * 
  * Mappings example
  *  {
  *     a: "sourceKey",
  *     b: "destinationKey"
  *   }
  * 
  * Nested elements use dot notation. Only supports sourceKey.
  * Destination key is always flatend.
  * 
  *   {
  *     a: "sourceKey.value",
  *     b: "destinationKey"
  *  }
  *
  * Nested elements in array. use key.
  * Destination key is always flatend.
  * 
  *   {
  *     a: "sourceKey.value.0",
  *     b: "destinationKey"
  *  }
  * @param {*} obj 
  * @param {*} mappings 
  * @returns 
  */
 export function map(obj, mappings) {
    const destObj = {};
    for (let i = 0; i < mappings.length; i++) {
        const mapping = mappings[i];
        let value = mapping["a"].split(".").reduce((o, i) => o ? o[i] : undefined, obj);
        
        if (mapping.filter && mapping.filter instanceof Function && !mapping.filter(value)) {
            return;
        }

        if (mapping.mutations) {
            for (const [key, pairValue] of Object.entries(mapping.mutations)) {
                value = MUTATIONS[key]({value, destObj}, pairValue);
            }
        }
        
        destObj[mapping["b"]] = value;
    }
    destObj["_raw"] = obj;
    return destObj;
 }

 /**
  * Map List takes a list of objects and mappings.
  * The results are collected to a array and are returned.
  * @param {*} objList 
  * @param {*} mappings 
  * @returns 
  */
 export function mapList(objList, mappings) {
    const items = [];
    
    if (objList && objList instanceof Array) {
        for (let i = 0; i < objList.length; i++) {
            const result = map(objList[i], mappings);
            result && items.push(result);
        }
    }
  
    return items;
 }

 MUTATIONS.default = ({value}, {value : defaultValue, replaceEmpty}) => {
    return value === undefined || value === null  || (replaceEmpty && defaultValue.trim() === "" ) ? defaultValue : value;
 };

 MUTATIONS.compute = ({value}, {mutate}) => {
    return mutate && mutate instanceof Function ? mutate(value) : value;
 };

 MUTATIONS.write = ({value, destObj}, {mutate}) => {
    mutate && mutate instanceof Function && mutate(value, destObj);
    return value;
 };